import { createContext, useEffect, useState, isValidElement } from 'react';
import get from 'hs-lodash/get';
import treatmentsClient from './client';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export const treatmentContext = /*#__PURE__*/createContext(undefined);
/**
 * Treatment provider
 *
 * This deviates from the standard somewhat in that it also provides the option to have a function child
 * that is called with the resolved treatments. This is useful for using the treatments in the same
 * component that provides them.
 */
export const TreatmentProvider = ({
  children,
  placeholder = /*#__PURE__*/_jsx(_Fragment, {}),
  onResolve
}) => {
  const [resolved, setResolved] = useState();
  useEffect(() => {
    treatmentsClient.resolve(setResolved);
  }, []);
  useEffect(() => {
    if (onResolve && resolved) {
      onResolve();
    }
  }, [onResolve, resolved]);
  if (!resolved) {
    return placeholder;
  }
  return /*#__PURE__*/_jsx(treatmentContext.Provider, {
    value: resolved,
    children: /*#__PURE__*/isValidElement(children) ? children : children(resolved)
  });
};
export const getTreatment = (resolved, experiment, parameter) => {
  if (!resolved) {
    throw new Error('Treatment context not resolved');
  }
  const resolvedParameter = get(resolved, [experiment, 'parameters', parameter], {});
  return resolvedParameter;
};
export const getEnrollmentStatus = (resolved, experiment) => {
  if (!resolved) {
    throw new Error('Treatment context not resolved');
  }
  const resolvedParameter = get(resolved, [experiment, 'status', 'isEnrolled'], false);
  return resolvedParameter;
};
export const logExposure = experiment => {
  treatmentsClient.logExposure(experiment);
};